// deps
import React, { memo, ReactElement } from "react";
import { ShimmerV4 } from "./v4";

function Shimmer(): ReactElement {
    return <ShimmerV4 />;
}

export default memo(Shimmer);
